import Grid from '../../grid/Grid';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { clientIdMgmtHeaders, generateGridData } from '../utils';
import { RootState } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import LLAdminPreviewTab from '../previewTab/previewPane';
import { ReactComponent as Add } from '../../../icons/AddNew.svg';
import loader from '../../../assets/loader.gif';
import { config } from '../../grid/config';
import { useCallback, useEffect, useState } from 'react';
import { getAllMasterData, getEndPoint } from '../../contactTabs/utils';
import axios from 'axios';
import { ContactType } from '../../contactTabs/constants';
import AddMastersScreen from '../../contactTabs/AddMastersScreen';

import notify from '../../../services/toasterService';

import {
    setClientsData,
    setCountryData,
    setCountryPhoneData,
    setCurrencyData,
    setLaungageData,
    setStatesData,
    setTabHeading,
    setTimezoneData,
} from '../../contactTabs/contactReducer';
import ContactsDetailsPanel from '../../ContactsDetailsPanel/ContactsDetailsPanel';

export default function CompanyCodeManagement() {
    const [dataSource, setDataSource] = useState<any>([]);
    const [addScreen, setAddScreen] = useState(false);
    const dispatch = useDispatch();

    /* Get Client data from Grid Reducer */
    const selectedRowData = useSelector(
        (state: RootState) => state.gridReducer.selectedRowData
    );
    // console.log(selectedRowData, 'selectedRowData');

    /* Get Client data from LL admin Reducer */
    // const clientMgmt = useSelector(
    //     (state: RootState) => state.lladminReducer.clientsData
    // );
    const getSelectedRecord = (e: any) => {
        //console.log(e)
    };
    const getDeSelectedRecord = (e: any) => {
        //  seletedDataToExport(e);
    };
    const loaderStatus = useSelector(
        (state: RootState) => state.lladminReducer.isLoaderShow
    );
    let gridHieght = 'calc(100vh - 420px)';

    useEffect(() => {
        getCompanyDetails();
        handleGetMastersForComapnyCodes();
    }, []);

    const getCompanyDetails = useCallback(async () => {
        const companyCodeEndPoint = getEndPoint(ContactType.COMPANY_CODES);
        const response = await axios.get(companyCodeEndPoint);
        if (response.status === 200) {
            setDataSource(response.data || []);
        }
    }, []);

    const handleGetMastersForComapnyCodes = async () => {
        const lanEndpoint = getAllMasterData('Language');
        const timeZonendpoint = getAllMasterData('TimeZone');
        const cuurencyCodeEndpoint = getAllMasterData('CurrencyCode');
        const clientListEndPoint = getAllMasterData('Client');
        const countryEndpoint = getAllMasterData('Country');
        const countryCodeEndpoint = getAllMasterData('CountryCodePhone');
        const lanResult = await axios.get(lanEndpoint).catch((err) => err);
        const timeZoneResult = await axios
            .get(timeZonendpoint)
            .catch((err) => err);
        const cureencyCoderesult = await axios
            .get(cuurencyCodeEndpoint)
            .catch((err) => err);
        const clientsresult = await axios
            .get(clientListEndPoint)
            .catch((err) => err);
        const countryresult = await axios
            .get(countryEndpoint)
            .catch((err) => err);
        const countryCoderesult = await axios
            .get(countryCodeEndpoint)
            .catch((err) => err);
        dispatch(setCurrencyData(cureencyCoderesult.data));
        dispatch(setTimezoneData(timeZoneResult.data));
        dispatch(setLaungageData(lanResult.data));
        dispatch(setClientsData(clientsresult.data));
        dispatch(setCountryPhoneData(countryCoderesult.data));
        dispatch(setCountryData(countryresult.data));
        dispatch(setTabHeading(ContactType.COMPANY_CODES));
        // const statesEndpoint = getAllMasterData('StateList');
        // const statesResult = await axios.get(statesEndpoint).catch(err => err);
        dispatch(setStatesData([]));
    };

    return (
        <div className="contact-screen">
            {addScreen && (
                <AddMastersScreen
                    addScreen={addScreen}
                    setAddScreen={() => {
                        setAddScreen(false);
                        getCompanyDetails();
                    }}
                    tabName={ContactType.COMPANY_CODES}
                />
            )}
            <div className="col-sm-12 col-md-12 col-lg-12 pt-5">
                <div className="col-sm-6 pl-0">
                    <p className="child-tab-title">Company Codes</p>
                </div>
                <div className="col-sm-6">
                    <ButtonComponent
                        onClick={() => setAddScreen(true)}
                        className="iconCopy float-right ml-1"
                    >
                        <Add />
                    </ButtonComponent>
                </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 ">
                <div className="contacts-wrapper d-flex justify-content-between">
                    <div className="masterDataGrid">
                        {loaderStatus ? (
                            <div className="LoadImg">
                                <img className="loaderClass" src={loader} />
                            </div>
                        ) : (
                            <Grid
                                config={config['Company Codes']}
                                // data={dataSource}
                                data={generateGridData(
                                    'Company Codes',
                                    dataSource
                                )}
                                width={'100%'}
                                height={gridHieght}
                                onRowSelect={getSelectedRecord}
                                onRowDeselect={getDeSelectedRecord}
                            />
                        )}
                    </div>

                    {selectedRowData && selectedRowData.length > 0 ? (
                        <div
                            className="detailsTab"
                            style={{ height: 'calc(100vh - 250px)' }}
                        >
                            <ContactsDetailsPanel />
                        </div>
                    ) : (
                        <>
                            <div
                                style={{ height: 'calc(100vh - 250px)' }}
                                className="detailsTabEmpty d-flex align-items-center"
                            >
                                <div className="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-center">
                                    <p className="selectTextForEmpty ">
                                        Select Company to view details{' '}
                                    </p>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
